import React, { FC } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { FormattedDateTime } from 'transfix-ui/components/FormattedDateTime'
import { Typography, Box, Divider } from 'transfix-ui/core'
import { DedicatedLanesResponse } from 'apps/marketplace/apiTypes/dedicatedLanes'
import { Card } from 'transfix-ui'
import { getDedicatedLaneInfo, parseLoadingMethod } from './DedicatedLanesOfferRow'
import { LaneOffersMobileInformation } from './LaneOffersMobileInformation'

export interface IDedicatedLanesOfferRowMobileProps {
  dedicatedLane: DedicatedLanesResponse
}

export const DedicatedLanesOfferRowMobile: FC<IDedicatedLanesOfferRowMobileProps> = ({
  dedicatedLane,
}) => {
  const history = useHistory()
  const { search } = useLocation()

  const {
    deliveryCity,
    deliveryLoadingMethod,
    deliveryStateCode,
    endDate,
    equipmentName,
    id,
    pickupCity,
    pickupLoadingMethod,
    pickupStateCode,
    startDate,
    volume,
  } = getDedicatedLaneInfo(dedicatedLane) || {}

  const openOfferDetailsHandler = () => {
    history.push(`/book/${id}/lane-details${search}`)
  }

  return (
    <Card>
      <Box onClick={openOfferDetailsHandler}>
        <Box pt={2} data-test='lane-offer-row-pickup'>
          <LaneOffersMobileInformation
            city={pickupCity || ''}
            stateCode={pickupStateCode || ''}
            mapMarkerType='pickup'
            subtitle={parseLoadingMethod(pickupLoadingMethod)}
          />
        </Box>
        <Box pt={2} data-test='lane-offer-row-delivery'>
          <LaneOffersMobileInformation
            city={deliveryCity || ''}
            stateCode={deliveryStateCode || ''}
            mapMarkerType='delivery'
            subtitle={parseLoadingMethod(deliveryLoadingMethod)}
          />
        </Box>
        <Box pt={2} pb={2}>
          <Divider />
        </Box>
        <Box display='flex'>
          <div className='w-80' data-test='lane-offer-row-volume'>
            <Typography display='inline' variant='subtitle1'>
              {volume} loads
            </Typography>
            <Typography display='inline' color='textSecondary'>
              {' '}
              / week
            </Typography>
          </div>
          <div className='w-20'>
            <Typography variant='body2' color='textSecondary'>
              {equipmentName}
            </Typography>
          </div>
        </Box>
        <Box>
          <Typography variant='body2' color='textSecondary'>
            <FormattedDateTime
              displayTimezone='America/New_York'
              datetime={startDate}
              format='dateAndYear'
            />
            {' - '}
            <FormattedDateTime
              displayTimezone='America/New_York'
              datetime={endDate}
              format='dateAndYear'
            />
          </Typography>
        </Box>
      </Box>
    </Card>
  )
}
